import { render } from "./IdentityExamineImg.vue?vue&type=template&id=371d4f65&scoped=true"
import script from "./IdentityExamineImg.vue?vue&type=script&lang=js"
export * from "./IdentityExamineImg.vue?vue&type=script&lang=js"

import "./IdentityExamineImg.vue?vue&type=style&index=0&id=371d4f65&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-371d4f65"]])

export default __exports__